import { useCallback } from "react";
import { useToastHandler } from "./useToastHandler";

export const useBannerHandlers = (store) => {
  const { executeSyncWithToast } = useToastHandler(store);

  const handleShare = useCallback(() => {
    const { selectedDocuments, selectedFolders } = store.selectionStore;

    if (selectedDocuments.length > 0 || selectedFolders.length > 0) {
      const virtualItem = {
        type: selectedFolders.length > 0 ? "folder" : "document",
        name: `${
          selectedDocuments.length + selectedFolders.length
        } items selected`,
      };

      executeSyncWithToast(store.openShareModal, virtualItem, "mixed");
    }
  }, [store, executeSyncWithToast]);

  const handleMove = useCallback(() => {
    store.openMoveModal();
  }, [store]);

  return {
    handleShare,
    handleMove,
  };
};
